var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      ref: "popover",
      attrs: {
        placement: "bottom-start",
        trigger: "click",
        disabled: _vm.disabled,
      },
      on: { show: _vm.onShowPopover, hide: _vm.onHidePopover },
    },
    [
      _c("el-tree", {
        ref: "tree",
        staticClass: "select-tree",
        style: "min-width: " + _vm.treeWidth,
        attrs: {
          "highlight-current": "",
          "show-checkbox": _vm.showCheckbox,
          "check-strictly": _vm.checkStrictly,
          "check-on-click-node": _vm.checkOnClickNode,
          "node-key": _vm.props.value,
          data: _vm.data,
          props: _vm.props,
          "expand-on-click-node": false,
          "filter-node-method": _vm.filterNode,
          "default-expand-all": false,
          "default-expanded-keys": _vm.defaultExpandedKeys,
        },
        on: { "node-click": _vm.onClickNode, "check-change": _vm.onCheckNode },
      }),
      _vm._v(" "),
      _c(
        "el-input",
        {
          ref: "input",
          class: { rotate: _vm.showStatus, ellipsis: true },
          style: "width: " + _vm.width + "px",
          attrs: {
            slot: "reference",
            clearable: "",
            readonly: "",
            disabled: _vm.disabled,
            placeholder: _vm.placeholder,
          },
          nativeOn: {
            mouseenter: function ($event) {
              _vm.inputHovering = true
            },
            mouseleave: function ($event) {
              _vm.inputHovering = false
            },
          },
          slot: "reference",
          model: {
            value: _vm.labelModel,
            callback: function ($$v) {
              _vm.labelModel = $$v
            },
            expression: "labelModel",
          },
        },
        [
          _c("template", { slot: "suffix" }, [
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.showClose,
                  expression: "!showClose",
                },
              ],
              staticClass: "el-select__caret el-input__icon el-icon-arrow-down",
            }),
            _vm._v(" "),
            _vm.showClose
              ? _c("i", {
                  staticClass:
                    "el-select__caret el-input__icon el-icon-circle-close",
                  on: { click: _vm.handleClearClick },
                })
              : _vm._e(),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }